<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>内容设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create-content></create-content>
      </div>
      <content-list></content-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import ContentList from './components/list';
import CreateContent from './components/create';
import { mapActions } from 'vuex';

export default {
  name: 'ContentSetting',
  components: {
    ContentList,
    CreateContent
  },
  methods: {
    ...mapActions('contentSetting', ['list'])
  },
  created() {
    this.list();
  }
};
</script>

<style lang="less" scoped></style>
